var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("parameter to map:  "),_c('b-form-select',{staticStyle:{"border":"1px solid gray","width":"auto"},attrs:{"options":_vm.parameterOptions},model:{value:(_vm.parameterToMap),callback:function ($$v) {_vm.parameterToMap=$$v},expression:"parameterToMap"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }